import {
    loggedInLinks,
    loggedOutLinks,
    adminLinks
} from '../services/ui/navigatonLinks';

export const NAVBAR_LINKS_REFRESHED = 'NAVBAR_LINKS_REFRESHED';

export function refreshLinks(currentPathname, isLoggedIn, isPlatformAdmin) {

    if (!isLoggedIn) {
        return {
            type: NAVBAR_LINKS_REFRESHED,
            links: applyInitialLinkStates(currentPathname, loggedOutLinks)
        };
    }

    if (isPlatformAdmin) {
        return {
            type: NAVBAR_LINKS_REFRESHED,
            links: applyInitialLinkStates(currentPathname, [...loggedInLinks, ...adminLinks])
        };
    }

    return {
        type: NAVBAR_LINKS_REFRESHED,
        links: applyInitialLinkStates(currentPathname, loggedInLinks)
    };
}

function applyInitialLinkStates(currentPathname, links) {

    return links.map(link => {
        return {
            ...link,
            active: link.link === currentPathname || isChildLinkActive(currentPathname, link.children),
            expanded: link.link === currentPathname || isChildLinkActive(currentPathname, link.children),
            children: applyInitialLinkStates(currentPathname, link.children)
        }
    });
}

function isChildLinkActive(currentPathname, links) {

    for (let i = 0; i < links.length; i++) {

        if (currentPathname === links[i].link) {
            return true;
        }
    }

    return false;
}

export function toggleLinkExpansion(links, linkId) {

    return {
        type: NAVBAR_LINKS_REFRESHED,
        links: applyLinkExpansion(links, linkId)
    };
}

function applyLinkExpansion(links, linkIdToExpand) {

    return links.map(link => {
        return {
            ...link,
            expanded: link.id === linkIdToExpand ? !link.expanded : link.expanded,
            children: applyLinkExpansion(link.children, linkIdToExpand)
        }
    });
}